import React, { useState } from 'react';
import Button from '../../components/Button/Button';
import Input from '../../components/Input/Input';
import TeamBox from '../../components/TeamBox/TeamBox';
import { useNavigate } from 'react-router-dom';
import './teamsview.scss';
import Spinner from '../../components/Spinner/Spinner';
import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { useRef } from 'react';
import base from '../../apis';

export default function TeamsView() {
  const navigate = useNavigate();
  const [teams, setTeams] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchParam, setSearchParam] = useState('');
  const TEAMS = useRef([]);

  useEffect(() => {
    const controller = new AbortController();
    setIsLoading(true);
    base
      .get('/operations/marketing_teams/', {
        signal: controller.signal,
      })
      .then((res) => {
        setIsLoading(false);
        setTeams(res.data);
        TEAMS.current = res.data;
        if (res.data.length === 0) {
          toast.warn('No teams found');
        }
      })
      .catch((err) => {
        setIsLoading(false);
        toast.error('Error loading teams');
      });

    return () => {
      controller.abort();
    };
  }, []);

  const onSearch = (e) => {
    e.preventDefault();
    if (searchParam === '') {
      setTeams(TEAMS.current);
      return;
    }
    const filtered = TEAMS.current.filter((team) => team.name.toLowerCase().includes(searchParam));
    setTeams(filtered);
  };

  return (
    <>
      {isLoading && <Spinner />}
      <div className="teamsview">
        <div className="teamsview__header">
          <h1>Teams</h1>
          <form onSubmit={onSearch}>
            <Input
              placeholder="By Team's name"
              type="search"
              value={searchParam}
              onChange={(e) => setSearchParam(e.target.value)}
            />
            <Button
              style={{
                width: 'fit-content',
                padding: '10px 30px',
                color: 'white',
                fontSize: '16px',
                backgroundColor: 'var(--primary-color)',
              }}
              type="submit"
              text="Filter"
            />
          </form>
        </div>
        <div className="teamsview__body">
          {teams.map(({ id, members_count, name }) => (
            <TeamBox
              onClick={(color) => navigate(`${id}`, { state: { color } })}
              key={id}
              numOfMembers={members_count}
              teamName={name}
            />
          ))}
        </div>
      </div>
    </>
  );
}
